import { createSignal, Show } from 'solid-js'
import { A, useLocation, useNavigate } from '@solidjs/router'
import { userStore } from '/web/store'
import { isLoggedIn } from '/web/store/api'

export default function AccountSidebar(props: { openHelp?: boolean }) {
  const [open, setOpen] = createSignal(props.openHelp || false)
  const location = useLocation()
  const pathname = location.pathname

  const user = userStore()

  const nav = useNavigate()

  return (
    <>
      {/* desktop */}
      <aside class="left gray-to-tran hidden h-full w-full max-w-[18rem] rounded-lg px-6 py-8 text-[19px] font-normal lg:block xl:max-w-[20rem]">
        {/* my account section */}
        <ul class="flex flex-col items-start gap-9">
          {/* link */}
          <li>
            <button
              class="flex items-center gap-4"
              onClick={() => {
                if (isLoggedIn()) {
                  userStore.buyTokensModal(true)
                } else {
                  userStore.loginModal(true)
                }
              }}
            >
              <div class="icon">
                <img width={20} height={20} src="/images/icons/wallet.svg" alt="icon" />
              </div>
              <div class="text space-y-2">
                <h3 class="text-2xl font-bold">
                  {user?.profile?.totalAvailableTokens || 0} Tokens
                </h3>
              </div>
            </button>
          </li>
          {/* link */}
          {/* 
          <li>
            <A href="#" class="flex items-center gap-4">
              <div class="icon">
                <img width={20} height={20} src="/images/icons/inbox.svg" alt="icon" />
              </div>
              <div class="text">Inbox</div>
            </A>
          </li>
          */}
          {/* link */}
          {/* 
          <li>
            <A href="#" class="flex items-center gap-4">
              <div class="icon">
                <img width={20} height={20} src="/images/icons/notification.svg" alt="icon" />
              </div>
              <div class="text">Notifications</div>
            </A>
          </li>
          */}
          {/* link */}
          <Show when={isLoggedIn()}>
            <li>
              <A href="/subscriptions" class="flex items-center gap-4">
                <div class="icon">
                  <img width={20} height={20} src="/images/icons/subscription.svg" alt="icon" />
                </div>
                <div class={`text ${pathname === '/subscriptions' && 'text-cosplay-red'}`}>
                  Subscriptions
                </div>
              </A>
            </li>

            {/* link */}
            <li>
              <A href="/payment-history" class="flex items-center gap-4">
                <div class="icon">
                  <img width={20} height={20} src="/images/icons/history.svg" alt="icon" />
                </div>
                <div
                  class={`text ${pathname.startsWith('/payment-history') && 'text-cosplay-red'}`}
                >
                  Payment History
                </div>
              </A>
            </li>
            {/* link */}
            <li>
              <A href="/settings" class="flex items-center gap-4">
                <div class="icon">
                  <img width={20} height={20} src="/images/icons/gear.svg" alt="icon" />
                </div>
                <div class={`text ${pathname === '/settings' && 'text-cosplay-red'}`}>Settings</div>
              </A>
            </li>
            {/* link */}
            <li>
              <a
                onClick={() => {
                  userStore.logout()
                  window.location.reload()
                }}
                class="flex cursor-pointer items-center gap-4"
              >
                <div class="icon">
                  <img width={20} height={20} src="/images/icons/exit.svg" alt="icon" />
                </div>
                <div class="text">Sign Out</div>
              </a>
            </li>
          </Show>
          <Show when={user?.user?.admin}>
            {/* Admin section with divider */}
            <div class="w-full border-t border-white pt-6">
              <h3 class="mb-4 text-lg font-semibold">Admin</h3>
              <ul class="flex flex-col items-start gap-4">
                <li>
                  <A href="/admin/transactions" class="flex items-center gap-4">
                    <div class="icon">
                      <img width={20} height={20} src="/images/icons/history.svg" alt="icon" />
                    </div>
                    <div class={`text ${pathname === '/admin/transactions' && 'text-cosplay-red'}`}>
                      All Transactions
                    </div>
                  </A>
                </li>
                <li>
                  <A href="/admin/subs" class="flex items-center gap-4">
                    <div class="icon">
                      <img width={20} height={20} src="/images/icons/subscription.svg" alt="icon" />
                    </div>
                    <div class={`text ${pathname === '/admin/subs' && 'text-cosplay-red'}`}>
                      All Subscriptions
                    </div>
                  </A>
                </li>
                <li>
                  <A href="/admin/users" class="flex items-center gap-4">
                    <div class="icon">
                      <img width={20} height={20} src="/images/icons/user.svg" alt="icon" />
                    </div>
                    <div class={`text ${pathname === '/admin/users' && 'text-cosplay-red'}`}>
                      All Users
                    </div>
                  </A>
                </li>
              </ul>
            </div>
          </Show>
          {/* Help & Support links with divider */}
          <div class="w-full border-t border-white pt-6">
            <ul class="flex flex-col items-start gap-4">
              <li>
                <A href="/faq" class="flex items-center gap-4">
                  <div class="icon">
                    <img width={20} height={20} src="/images/icons/question.svg" alt="icon" />
                  </div>
                  <span class={`${pathname === '/faq' && 'text-cosplay-red'}`}>FAQ</span>
                </A>
              </li>

              <li>
                <A href="/contact-us" class="flex items-center gap-4">
                  <div class="icon">
                    <img width={20} height={20} src="/images/icons/envelope.svg" alt="icon" />
                  </div>
                  <span class={`${pathname === '/contact-us' && 'text-cosplay-red'}`}>
                    Contact Us
                  </span>
                </A>
              </li>
            </ul>
          </div>
        </ul>
      </aside>
    </>
  )
}
